import { ref, computed, watchEffect } from "vue";
import { useCore } from "@/core/core";

const { config } = useCore();

// speed of animations for right part and activities
const DEFAULT_ANIMATION_SPEED_MS = 200;

// state
const speedMs = ref(DEFAULT_ANIMATION_SPEED_MS); // in ms
// the style we can add to css properties to animate.
const style = computed(() => `transition: all ${speedMs.value / 1000}s ease-in-out;`);
const styleObj = computed(() => {
    return {
        transition: `all ${speedMs.value / 1000}s ease-in-out`
    }
});

watchEffect(() => {
    toggleAnimations(config.animations);
    speedMs.value = config.animations ? DEFAULT_ANIMATION_SPEED_MS : 0;
});


/** 
 * Turns on or off animations in PrimeVue 4 and other 
 **/
export function toggleAnimations(enable: boolean): void {
    const styleId = 'disable-animations-style';
    const existingStyle = document.getElementById(styleId);

    if (!enable) {
        // Voeg de style-tag toe als die nog niet bestaat
        if (!existingStyle) {
            const style = document.createElement('style');
            style.id = styleId;
            style.innerText = `
          .p-component {
            transition: none !important;
            animation-duration: 0s !important;
          }
        `;
            document.head.appendChild(style);
        }
    } else {
        // Verwijder de style-tag als deze bestaat
        if (existingStyle) {
            existingStyle.remove();
        }
    }
}

/**
 * Use animation styles for our own components, so they act the same as the PrimeVue components.
 * @returns speedMs and style
 */
export function useAnimations() {
    return { speedMs, style, styleObj };
}